import React from 'react';
import { Provider } from 'react-redux';

import configureStore from './store/configureStore';
import ErrorBoundary from './ErrorBoundary';
import Frontoffice from './Frontoffice';

const App = () => {
  const store = configureStore();

  const loadFrontoffice = (
    <ErrorBoundary>
      <Frontoffice />
    </ErrorBoundary>
  );

  return <Provider store={store}>{loadFrontoffice}</Provider>;
};

export default App;
